const gmatQuant = [
  // ===================== ARITHMETIC (Easy) =====================
  {
    id: 1,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 90,
    question: "A number increased by 25% becomes 100. What was the original number?",
    image: null,
    options: ["A. 75", "B. 80", "C. 85", "D. 90"],
    answer: "B"
  },
  {
    id: 2,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 410,
    discrimination: 0.85,
    timeLimit: 90,
    question: "What is the average of 10, 20, 30, and 40?",
    image: null,
    options: ["A. 20", "B. 25", "C. 30", "D. 35"],
    answer: "B"
  },
  {
    id: 3,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.9,
    timeLimit: 95,
    question: "A shopkeeper buys an item for ₹200 and sells it for ₹250. What is the profit percentage?",
    image: null,
    options: ["A. 20%", "B. 25%", "C. 30%", "D. 15%"],
    answer: "B"
  },
  {
    id: 4,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 430,
    discrimination: 0.9,
    timeLimit: 95,
    question: "What is 15% of 240?",
    image: null,
    options: ["A. 30", "B. 32", "C. 36", "D. 40"],
    answer: "C"
  },
  {
    id: 5,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.9,
    timeLimit: 100,
    question: "A train travels 60 km in 1.5 hours. What is its speed in km/h?",
    image: null,
    options: ["A. 35", "B. 40", "C. 45", "D. 50"],
    answer: "B"
  },
  {
    id: 6,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 450,
    discrimination: 0.95,
    timeLimit: 100,
    question: "If the ratio of boys to girls in a class is 3:2 and there are 12 boys, how many girls are there?",
    image: null,
    options: ["A. 6", "B. 8", "C. 9", "D. 10"],
    answer: "B"
  },
  {
    id: 7,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 460,
    discrimination: 0.95,
    timeLimit: 105,
    question: "A sum of ₹1000 is invested at 5% simple interest per annum. What is the interest after 2 years?",
    image: null,
    options: ["A. ₹50", "B. ₹100", "C. ₹150", "D. ₹200"],
    answer: "B"
  },
  {
    id: 8,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 470,
    discrimination: 0.95,
    timeLimit: 105,
    question: "What is the sum of the first 10 natural numbers?",
    image: null,
    options: ["A. 45", "B. 50", "C. 55", "D. 60"],
    answer: "C"
  },
  {
    id: 9,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 480,
    discrimination: 1.0,
    timeLimit: 110,
    question: "A car covers 120 km using 10 litres of fuel. What is its mileage in km per litre?",
    image: null,
    options: ["A. 10", "B. 12", "C. 14", "D. 15"],
    answer: "B"
  },
  {
    id: 10,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Easy",
    difficultyScore: 490,
    discrimination: 1.0,
    timeLimit: 110,
    question: "If a number is decreased by 20% and becomes 80, what was the original number?",
    image: null,
    options: ["A. 90", "B. 95", "C. 100", "D. 105"],
    answer: "C"
  },

  // ===================== ARITHMETIC (Medium) =====================
  {
    id: 11,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 500,
    discrimination: 1.1,
    timeLimit: 120,
    question: "A shopkeeper marks up an item by 40% and then gives a discount of 10% on the marked price. What is the overall percentage profit?",
    image: null,
    options: ["A. 24%", "B. 26%", "C. 28%", "D. 30%"],
    answer: "B"
  },
  {
    id: 12,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 515,
    discrimination: 1.1,
    timeLimit: 125,
    question: "Two pipes can fill a tank in 6 hours and 8 hours respectively. How long will they take to fill the tank together?",
    image: null,
    options: ["A. 24/7 hours", "B. 3 hours", "C. 4 hours", "D. 7/24 hours"],
    answer: "A"
  },
  {
    id: 13,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 530,
    discrimination: 1.15,
    timeLimit: 130,
    question: "A sum of money doubles itself in 8 years at simple interest. What is the rate of interest per annum?",
    image: null,
    options: ["A. 10%", "B. 12.5%", "C. 15%", "D. 20%"],
    answer: "B"
  },
  {
    id: 14,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 545,
    discrimination: 1.15,
    timeLimit: 130,
    question: "The average weight of 8 people increases by 2.5 kg when a new person replaces one who weighs 65 kg. What is the weight of the new person?",
    image: null,
    options: ["A. 75 kg", "B. 80 kg", "C. 85 kg", "D. 90 kg"],
    answer: "C"
  },
  {
    id: 15,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 560,
    discrimination: 1.2,
    timeLimit: 135,
    question: "A mixture of milk and water is in the ratio 5:3. If the total mixture is 40 litres, how much water does it contain?",
    image: null,
    options: ["A. 10 litres", "B. 12 litres", "C. 15 litres", "D. 18 litres"],
    answer: "C"
  },
  {
    id: 16,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 575,
    discrimination: 1.2,
    timeLimit: 135,
    question: "A man's monthly salary is ₹40,000. He spends 25% on rent, 30% on food, and saves the rest. How much does he save?",
    image: null,
    options: ["A. ₹16,000", "B. ₹18,000", "C. ₹20,000", "D. ₹22,000"],
    answer: "B"
  },
  {
    id: 17,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 590,
    discrimination: 1.2,
    timeLimit: 140,
    question: "If 20 workers can complete a task in 15 days, how many days will 30 workers take to complete the same task?",
    image: null,
    options: ["A. 8", "B. 10", "C. 12", "D. 14"],
    answer: "B"
  },
  {
    id: 18,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.25,
    timeLimit: 145,
    question: "A car travels the first half of a journey at 40 km/h and the second half at 60 km/h. What is the average speed for the entire journey?",
    image: null,
    options: ["A. 48 km/h", "B. 50 km/h", "C. 52 km/h", "D. 55 km/h"],
    answer: "A"
  },
  {
    id: 19,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 610,
    discrimination: 1.25,
    timeLimit: 145,
    question: "What is the compound interest on ₹2000 for 2 years at 10% per annum, compounded annually?",
    image: null,
    options: ["A. ₹400", "B. ₹410", "C. ₹420", "D. ₹440"],
    answer: "C"
  },
  {
    id: 20,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Medium",
    difficultyScore: 620,
    discrimination: 1.25,
    timeLimit: 150,
    question: "A number is increased by 10% and then decreased by 10%. What is the net percentage change?",
    image: null,
    options: ["A. No change", "B. 1% decrease", "C. 1% increase", "D. 2% decrease"],
    answer: "B"
  },

  // ===================== ARITHMETIC (Hard) =====================
  {
    id: 21,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 630,
    discrimination: 1.4,
    timeLimit: 150,
    question: "A sum of money is divided among A, B, and C in the ratio 2:3:5. If C receives ₹6000 more than A, what is the total sum?",
    image: null,
    options: ["A. ₹18,000", "B. ₹20,000", "C. ₹22,000", "D. ₹24,000"],
    answer: "B"
  },
  {
    id: 22,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 645,
    discrimination: 1.4,
    timeLimit: 155,
    question: "A container has 40 litres of a mixture that is 25% water and the rest milk. How many litres of water must be added to make the water content 40% of the new mixture?",
    image: null,
    options: ["A. 8 litres", "B. 10 litres", "C. 12 litres", "D. 15 litres"],
    answer: "B"
  },
  {
    id: 23,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 660,
    discrimination: 1.45,
    timeLimit: 160,
    question: "A works twice as fast as B. Working together, they can complete a job in 12 days. In how many days can A alone complete the job?",
    image: null,
    options: ["A. 15", "B. 18", "C. 20", "D. 24"],
    answer: "B"
  },
  {
    id: 24,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 675,
    discrimination: 1.45,
    timeLimit: 160,
    question: "A boat travels 30 km upstream in 6 hours and returns downstream in 3 hours. What is the speed of the boat in still water?",
    image: null,
    options: ["A. 6.5 km/h", "B. 7 km/h", "C. 7.5 km/h", "D. 8 km/h"],
    answer: "C"
  },
  {
    id: 25,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 690,
    discrimination: 1.45,
    timeLimit: 165,
    question: "The sum of three consecutive even numbers is 90. What is the product of the largest and smallest of the three?",
    image: null,
    options: ["A. 868", "B. 896", "C. 900", "D. 930"],
    answer: "B"
  },
  {
    id: 26,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.5,
    timeLimit: 170,
    question: "A trader mixes 20 kg of rice costing ₹40/kg with 30 kg of rice costing ₹60/kg. What is the average cost per kg of the mixture?",
    image: null,
    options: ["A. ₹48", "B. ₹50", "C. ₹52", "D. ₹54"],
    answer: "C"
  },
  {
    id: 27,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 710,
    discrimination: 1.5,
    timeLimit: 175,
    question: "A alone can complete a piece of work in 20 days and B alone in 30 days. They work together for 5 days, after which A leaves. In how many more days will B complete the remaining work?",
    image: null,
    options: ["A. 15 days", "B. 17.5 days", "C. 18 days", "D. 20 days"],
    answer: "B"
  },
  {
    id: 28,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 720,
    discrimination: 1.5,
    timeLimit: 180,
    question: "The difference between the compound interest and simple interest on a sum for 2 years at 10% per annum is ₹150. What is the sum?",
    image: null,
    options: ["A. ₹12,000", "B. ₹15,000", "C. ₹18,000", "D. ₹20,000"],
    answer: "B"
  },
  {
    id: 29,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 735,
    discrimination: 1.55,
    timeLimit: 185,
    question: "A sum of ₹8000 amounts to ₹9261 in 3 years at compound interest, compounded annually. What is the rate of interest?",
    image: null,
    options: ["A. 4%", "B. 5%", "C. 6%", "D. 7%"],
    answer: "B"
  },
  {
    id: 30,
    section: "Quantitative",
    topic: "Arithmetic",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.6,
    timeLimit: 190,
    question: "Two trains, 150 m and 100 m long, run on parallel tracks in opposite directions at speeds of 60 km/h and 40 km/h. In approximately how many seconds will they cross each other?",
    image: null,
    options: ["A. 7", "B. 8", "C. 9", "D. 10"],
    answer: "C"
  },

  // ===================== ALGEBRA (Easy) =====================
  {
    id: 31,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 90,
    question: "If 3x - 4 = 11, what is the value of x?",
    image: null,
    options: ["A. 4", "B. 5", "C. 6", "D. 7"],
    answer: "B"
  },
  {
    id: 32,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 410,
    discrimination: 0.85,
    timeLimit: 90,
    question: "If y/3 + 5 = 9, what is the value of y?",
    image: null,
    options: ["A. 10", "B. 12", "C. 14", "D. 16"],
    answer: "B"
  },
  {
    id: 33,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.9,
    timeLimit: 95,
    question: "Simplify: 2(x + 3) - 4",
    image: null,
    options: ["A. 2x + 2", "B. 2x + 6", "C. 2x - 2", "D. 2x + 10"],
    answer: "A"
  },
  {
    id: 34,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 430,
    discrimination: 0.9,
    timeLimit: 95,
    question: "If x = 4, what is the value of x² - 3x + 2?",
    image: null,
    options: ["A. 4", "B. 5", "C. 6", "D. 7"],
    answer: "C"
  },
  {
    id: 35,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.9,
    timeLimit: 100,
    question: "If 5x = 2x + 12, what is the value of x?",
    image: null,
    options: ["A. 3", "B. 4", "C. 5", "D. 6"],
    answer: "B"
  },
  {
    id: 36,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 450,
    discrimination: 0.95,
    timeLimit: 100,
    question: "What is the value of x if 2x + 3 = x + 10?",
    image: null,
    options: ["A. 5", "B. 6", "C. 7", "D. 8"],
    answer: "C"
  },
  {
    id: 37,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 460,
    discrimination: 0.95,
    timeLimit: 105,
    question: "If a = 3 and b = 5, what is the value of 2a + 3b?",
    image: null,
    options: ["A. 19", "B. 20", "C. 21", "D. 22"],
    answer: "C"
  },
  {
    id: 38,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 470,
    discrimination: 0.95,
    timeLimit: 105,
    question: "Solve for x: x/4 - 2 = 3",
    image: null,
    options: ["A. 16", "B. 18", "C. 20", "D. 22"],
    answer: "C"
  },
  {
    id: 39,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 480,
    discrimination: 1.0,
    timeLimit: 110,
    question: "If 4(x - 1) = 16, what is the value of x?",
    image: null,
    options: ["A. 4", "B. 5", "C. 6", "D. 7"],
    answer: "B"
  },
  {
    id: 40,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Easy",
    difficultyScore: 490,
    discrimination: 1.0,
    timeLimit: 110,
    question: "Simplify: 3x + 2y - x + 5y",
    image: null,
    options: ["A. 2x + 7y", "B. 4x + 7y", "C. 2x + 3y", "D. 4x + 3y"],
    answer: "A"
  },

  // ===================== ALGEBRA (Medium) =====================
  {
    id: 41,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 500,
    discrimination: 1.1,
    timeLimit: 120,
    question: "If x² - 4 = 0, what are the possible values of x?",
    image: null,
    options: ["A. 2 and -2", "B. 4 and -4", "C. 2 only", "D. -2 only"],
    answer: "A"
  },
  {
    id: 42,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 515,
    discrimination: 1.1,
    timeLimit: 125,
    question: "If 2x + 3y = 12 and x = 3, what is the value of y?",
    image: null,
    options: ["A. 1", "B. 2", "C. 3", "D. 4"],
    answer: "B"
  },
  {
    id: 43,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 530,
    discrimination: 1.15,
    timeLimit: 130,
    question: "If x² + 6x + 9 = 0, what is the value of x?",
    image: null,
    options: ["A. 3", "B. -3", "C. 9", "D. -9"],
    answer: "B"
  },
  {
    id: 44,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 545,
    discrimination: 1.15,
    timeLimit: 130,
    question: "Solve the inequality: 3x - 5 > 7",
    image: null,
    options: ["A. x > 3", "B. x > 4", "C. x < 4", "D. x < 3"],
    answer: "B"
  },
  {
    id: 45,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 560,
    discrimination: 1.2,
    timeLimit: 135,
    question: "If f(x) = 2x² - 3x + 1, what is f(2)?",
    image: null,
    options: ["A. 1", "B. 2", "C. 3", "D. 4"],
    answer: "C"
  },
  {
    id: 46,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 575,
    discrimination: 1.2,
    timeLimit: 135,
    question: "If x + y = 10 and x - y = 4, what is the value of x?",
    image: null,
    options: ["A. 5", "B. 6", "C. 7", "D. 8"],
    answer: "C"
  },
  {
    id: 47,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 590,
    discrimination: 1.2,
    timeLimit: 140,
    question: "If 3^x = 81, what is the value of x?",
    image: null,
    options: ["A. 3", "B. 4", "C. 5", "D. 6"],
    answer: "B"
  },
  {
    id: 48,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.25,
    timeLimit: 145,
    question: "Simplify: (x + 3)(x - 3)",
    image: null,
    options: ["A. x² - 9", "B. x² + 9", "C. x² - 6x + 9", "D. x² - 6"],
    answer: "A"
  },
  {
    id: 49,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 610,
    discrimination: 1.25,
    timeLimit: 145,
    question: "If |x - 5| = 3, what are the possible values of x?",
    image: null,
    options: ["A. 8 and 2", "B. 8 and -2", "C. -8 and 2", "D. -8 and -2"],
    answer: "A"
  },
  {
    id: 50,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Medium",
    difficultyScore: 620,
    discrimination: 1.25,
    timeLimit: 150,
    question: "If x/2 + y/3 = 7 and x = 6, what is the value of y?",
    image: null,
    options: ["A. 9", "B. 10", "C. 12", "D. 14"],
    answer: "C"
  },

  // ===================== ALGEBRA (Hard) =====================
  {
    id: 51,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 630,
    discrimination: 1.4,
    timeLimit: 150,
    question: "If x² - 7x + 12 = 0, what is the sum of the roots?",
    image: null,
    options: ["A. 5", "B. 6", "C. 7", "D. 12"],
    answer: "C"
  },
  {
    id: 52,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 645,
    discrimination: 1.4,
    timeLimit: 155,
    question: "If 2x + 3y = 18 and 3x - y = 5, what is the value of x?",
    image: null,
    options: ["A. 2", "B. 3", "C. 4", "D. 5"],
    answer: "B"
  },
  {
    id: 53,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 660,
    discrimination: 1.45,
    timeLimit: 160,
    question: "If x² + y² = 25 and xy = 12, what is the value of (x + y)²?",
    image: null,
    options: ["A. 37", "B. 39", "C. 45", "D. 49"],
    answer: "D"
  },
  {
    id: 54,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 675,
    discrimination: 1.45,
    timeLimit: 160,
    question: "The equation x² - (k+4)x + 4k = 0 has two equal roots. What is the value of k?",
    image: null,
    options: ["A. 2", "B. 3", "C. 4", "D. 5"],
    answer: "C"
  },
  {
    id: 55,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 690,
    discrimination: 1.45,
    timeLimit: 165,
    question: "If a and b are the roots of x² - 5x + 6 = 0, what is the value of a² + b²?",
    image: null,
    options: ["A. 11", "B. 12", "C. 13", "D. 14"],
    answer: "C"
  },
  {
    id: 56,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.5,
    timeLimit: 170,
    question: "If x + 1/x = 3, what is the value of x² + 1/x²?",
    image: null,
    options: ["A. 5", "B. 6", "C. 7", "D. 9"],
    answer: "C"
  },
  {
    id: 57,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 710,
    discrimination: 1.5,
    timeLimit: 175,
    question: "Solve for x: (x - 2)/(x + 3) = 1/2",
    image: null,
    options: ["A. 5", "B. 6", "C. 7", "D. 8"],
    answer: "C"
  },
  {
    id: 58,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 720,
    discrimination: 1.5,
    timeLimit: 180,
    question: "If f(x) = x² - 2x + k has a minimum value of 5, what is the value of k?",
    image: null,
    options: ["A. 4", "B. 5", "C. 6", "D. 7"],
    answer: "C"
  },
  {
    id: 59,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 735,
    discrimination: 1.55,
    timeLimit: 185,
    question: "If the roots of x² - px + 18 = 0 are in the ratio 2:9, what is the value of p?",
    image: null,
    options: ["A. 9", "B. 10", "C. 11", "D. 12"],
    answer: "C"
  },
  {
    id: 60,
    section: "Quantitative",
    topic: "Algebra",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.6,
    timeLimit: 190,
    question: "How many pairs of positive integers (x, y) satisfy 3x + 2y = 23 with x < y?",
    image: null,
    options: ["A. 1", "B. 2", "C. 3", "D. 4"],
    answer: "B"
  },

  // ===================== NUMBER PROPERTIES (Easy) =====================
  {
    id: 61,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 90,
    question: "What is the smallest prime number?",
    image: null,
    options: ["A. 0", "B. 1", "C. 2", "D. 3"],
    answer: "C"
  },
  {
    id: 62,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 410,
    discrimination: 0.85,
    timeLimit: 90,
    question: "Which of the following numbers is even?",
    image: null,
    options: ["A. 47", "B. 52", "C. 63", "D. 71"],
    answer: "B"
  },
  {
    id: 63,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.9,
    timeLimit: 95,
    question: "What is the LCM of 4 and 6?",
    image: null,
    options: ["A. 10", "B. 12", "C. 16", "D. 24"],
    answer: "B"
  },
  {
    id: 64,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 430,
    discrimination: 0.9,
    timeLimit: 95,
    question: "What is the HCF of 12 and 18?",
    image: null,
    options: ["A. 4", "B. 6", "C. 8", "D. 9"],
    answer: "B"
  },
  {
    id: 65,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.9,
    timeLimit: 100,
    question: "Which of the following numbers is divisible by 3?",
    image: null,
    options: ["A. 124", "B. 135", "C. 146", "D. 158"],
    answer: "B"
  },
  {
    id: 66,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 450,
    discrimination: 0.95,
    timeLimit: 100,
    question: "What is the remainder when 17 is divided by 5?",
    image: null,
    options: ["A. 1", "B. 2", "C. 3", "D. 4"],
    answer: "B"
  },
  {
    id: 67,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 460,
    discrimination: 0.95,
    timeLimit: 105,
    question: "How many factors does the number 12 have?",
    image: null,
    options: ["A. 4", "B. 5", "C. 6", "D. 8"],
    answer: "C"
  },
  {
    id: 68,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 470,
    discrimination: 0.95,
    timeLimit: 105,
    question: "Which of the following is a prime number?",
    image: null,
    options: ["A. 21", "B. 29", "C. 33", "D. 45"],
    answer: "B"
  },
  {
    id: 69,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 480,
    discrimination: 1.0,
    timeLimit: 110,
    question: "What is the sum of the first 5 odd numbers?",
    image: null,
    options: ["A. 20", "B. 25", "C. 30", "D. 15"],
    answer: "B"
  },
  {
    id: 70,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Easy",
    difficultyScore: 490,
    discrimination: 1.0,
    timeLimit: 110,
    question: "Which of the following best describes the number 91?",
    image: null,
    options: ["A. Prime", "B. Composite", "C. Neither prime nor composite", "D. Both prime and composite"],
    answer: "B"
  },

  // ===================== NUMBER PROPERTIES (Medium) =====================
  {
    id: 71,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 500,
    discrimination: 1.1,
    timeLimit: 120,
    question: "What is the smallest number that must be added to 267 to make it divisible by 12?",
    image: null,
    options: ["A. 7", "B. 8", "C. 9", "D. 10"],
    answer: "C"
  },
  {
    id: 72,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 515,
    discrimination: 1.1,
    timeLimit: 125,
    question: "How many two-digit numbers are divisible by 7?",
    image: null,
    options: ["A. 11", "B. 12", "C. 13", "D. 14"],
    answer: "C"
  },
  {
    id: 73,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 530,
    discrimination: 1.15,
    timeLimit: 130,
    question: "What is the units digit of 7^23?",
    image: null,
    options: ["A. 1", "B. 3", "C. 7", "D. 9"],
    answer: "B"
  },
  {
    id: 74,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 545,
    discrimination: 1.15,
    timeLimit: 130,
    question: "If n is a positive integer and n² is divisible by 4, which of the following must be true?",
    image: null,
    options: ["A. n is odd", "B. n is even", "C. n is prime", "D. n is a multiple of 4"],
    answer: "B"
  },
  {
    id: 75,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 560,
    discrimination: 1.2,
    timeLimit: 135,
    question: "What is the LCM of 15, 20, and 25?",
    image: null,
    options: ["A. 150", "B. 200", "C. 300", "D. 250"],
    answer: "C"
  },
  {
    id: 76,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 575,
    discrimination: 1.2,
    timeLimit: 135,
    question: "What is the sum of all prime numbers between 10 and 30?",
    image: null,
    options: ["A. 100", "B. 112", "C. 120", "D. 130"],
    answer: "B"
  },
  {
    id: 77,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 590,
    discrimination: 1.2,
    timeLimit: 140,
    question: "A number, when divided by 7, leaves a remainder of 3 and gives a quotient of 8. What is the number?",
    image: null,
    options: ["A. 53", "B. 56", "C. 59", "D. 62"],
    answer: "C"
  },
  {
    id: 78,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.25,
    timeLimit: 145,
    question: "If x is a positive integer and x³ is even, which of the following must be true about x?",
    image: null,
    options: ["A. x is odd", "B. x is even", "C. x is prime", "D. x is a multiple of 3"],
    answer: "B"
  },
  {
    id: 79,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 610,
    discrimination: 1.25,
    timeLimit: 145,
    question: "What is the greatest common divisor (GCD) of 48 and 60?",
    image: null,
    options: ["A. 6", "B. 8", "C. 10", "D. 12"],
    answer: "D"
  },
  {
    id: 80,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Medium",
    difficultyScore: 620,
    discrimination: 1.25,
    timeLimit: 150,
    question: "How many multiples of 6 are there between 1 and 100?",
    image: null,
    options: ["A. 14", "B. 15", "C. 16", "D. 17"],
    answer: "C"
  },

  // ===================== NUMBER PROPERTIES (Hard) =====================
  {
    id: 81,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 630,
    discrimination: 1.4,
    timeLimit: 150,
    question: "What is the remainder when 2^100 is divided by 7?",
    image: null,
    options: ["A. 1", "B. 2", "C. 4", "D. 6"],
    answer: "B"
  },
  {
    id: 82,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 645,
    discrimination: 1.4,
    timeLimit: 155,
    question: "How many positive integers less than 100 are divisible by both 4 and 6?",
    image: null,
    options: ["A. 6", "B. 7", "C. 8", "D. 9"],
    answer: "C"
  },
  {
    id: 83,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 660,
    discrimination: 1.45,
    timeLimit: 160,
    question: "If N = 2³ × 3² × 5, how many total factors does N have?",
    image: null,
    options: ["A. 18", "B. 20", "C. 22", "D. 24"],
    answer: "D"
  },
  {
    id: 84,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 675,
    discrimination: 1.45,
    timeLimit: 165,
    question: "What is the smallest positive integer that leaves a remainder of 2 when divided by 5, and a remainder of 3 when divided by 7?",
    image: null,
    options: ["A. 12", "B. 15", "C. 17", "D. 22"],
    answer: "C"
  },
  {
    id: 85,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 690,
    discrimination: 1.45,
    timeLimit: 165,
    question: "What is the sum of the digits of the smallest 4-digit number divisible by 36?",
    image: null,
    options: ["A. 7", "B. 8", "C. 9", "D. 10"],
    answer: "C"
  },
  {
    id: 86,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.5,
    timeLimit: 170,
    question: "What is the smallest three-digit number that is divisible by both 8 and 9?",
    image: null,
    options: ["A. 108", "B. 126", "C. 144", "D. 162"],
    answer: "C"
  },
  {
    id: 87,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 710,
    discrimination: 1.5,
    timeLimit: 175,
    question: "How many trailing zeros are there in 15! (15 factorial)?",
    image: null,
    options: ["A. 2", "B. 3", "C. 4", "D. 5"],
    answer: "B"
  },
  {
    id: 88,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 720,
    discrimination: 1.5,
    timeLimit: 180,
    question: "What is the remainder when 5^40 is divided by 13?",
    image: null,
    options: ["A. 1", "B. 3", "C. 5", "D. 9"],
    answer: "A"
  },
  {
    id: 89,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 735,
    discrimination: 1.55,
    timeLimit: 185,
    question: "If p and q are distinct prime numbers, how many total factors does p²q have?",
    image: null,
    options: ["A. 4", "B. 5", "C. 6", "D. 8"],
    answer: "C"
  },
  {
    id: 90,
    section: "Quantitative",
    topic: "Number Properties",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.6,
    timeLimit: 190,
    question: "What is the smallest positive integer n such that n! is divisible by 1000?",
    image: null,
    options: ["A. 10", "B. 12", "C. 14", "D. 15"],
    answer: "D"
  }

];

export default gmatQuant;